import React from 'react';

import { Box, SxProps } from '@mui/material';
import { Controller } from 'react-hook-form';
import TextField from '@europrocurement/l2d-modules/modules/Offres/components/form/TextField';
import { FormContextType } from '@europrocurement/l2d-modules/modules/Offres/Package/Components/types';

type ComponentProps = {
    value?: string | null;
    inputName: string;
    context: FormContextType;
    placeholder?: string;
    sx?: SxProps;
};

/** Specific input for overridable field :
 * - Display overrided value as a place holder
 * - Clear input when there is no value
 */
const OverrideField: React.FunctionComponent<ComponentProps> = function ({
    inputName,
    context,
    value,
    placeholder,
    sx: sxProps,
}) {
    const inputReference = React.useRef<HTMLInputElement>(null);
    const {
        formState: { errors },
        control,
    } = context;

    // Clear field when there is no value
    React.useEffect(() => {
        if (!value && inputReference && inputReference.current) {
            inputReference.current.value = '';
            context.trigger();
        }
    }, [context, value]);

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={sxProps}
        >
            <Controller
                name={inputName}
                control={control}
                render={({ field }) => (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <TextField
                            sx={{ width: '100%', margin: 0 }}
                            {...field}
                            inputRef={inputReference}
                            placeholder={placeholder}
                            errors={errors}
                            required={false}
                        />
                    </Box>
                )}
            />
        </Box>
    );
};

export default OverrideField;
